export default __webpack_public_path__ + "static/purple-gradient-fallback-with-dark-transition-ee402306175669e9a9b514a37933fd88.png";